import { Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { MainLayout } from '@/shared/components/layout'
import { useAuth } from '@/shared/contexts/AuthContext'
import { useUnit } from '@/modules/units/contexts/UnitContext'
import { BillingProvider } from '@/modules/billing/BillingContext'
import { getProfile } from '@/modules/profile'
import { ContactsPage } from '@/modules/registrations/contacts'
import { ContactsPage as BillingContactsPage } from '@/modules/billing/ContactsPage'
import { ContactsPage as PoultryContactsPage } from '@/modules/poultry/ContactsPage'

export default function RegistrationsLayout() {
  const { user } = useAuth()
  const { currentUnit } = useUnit()
  const [profile, setProfile] = useState<any | null>(null)

  useEffect(() => {
    if (!user?.id) return
    getProfile(user.id)
      .then(setProfile)
      .catch((err) => console.error('Error loading profile in RegistrationsLayout', err))
  }, [user?.id])

  return (
    <MainLayout
      userName={profile?.full_name || user?.email}
      userId={user?.id}
      currentUnitId={profile?.current_unit_id || null}
    >
      <Routes>
        <Route path="contacts"         element={<ContactsPage />} />
        <Route path="billing/contacts" element={<BillingProvider><BillingContactsPage /></BillingProvider>} />
        <Route path="poultry/contacts"  element={<PoultryContactsPage />} />
      </Routes>
    </MainLayout>
  )
}
